/* eslint-disable import/prefer-default-export */
import { formatNumber } from '../../../utilities/formatHelpers';
import { currencies, exchange as exchangeConfig } from '../../../utilities/constants';
import { isClCard } from '../../../utilities/helpers';
import { mainStakingCurrency } from '../../Staking/constants';

export const getTotalBalance = (destination, wallets, rates, staking = 0) => {
  const _destination = destination?.toUpperCase();
  const result = {
    totalBalanceInFiat: 0,
    totalChangeInFiat: 0,
  };
  if (wallets && rates) {
    // eslint-disable-next-line no-restricted-syntax
    wallets.forEach((wallet) => {
      const { available_balance: availableBalance } = wallet;
      const currencyIconUpperCase = wallet.coin.toUpperCase();
      if (!isClCard(currencyIconUpperCase)) {
        const currency = currencies[currencyIconUpperCase];
        const _source = currencyIconUpperCase;

        let rateData;
        let dayChange;
        let walletBalance = formatNumber(availableBalance * currency.conversion, currency.decimal);
        if (staking > 0 && wallet?.coin === mainStakingCurrency) {
          walletBalance = formatNumber(
            (parseFloat(availableBalance) + staking) * currency.conversion,
            currency.decimal
          );
        }

        let walletValue;
        if (_source === _destination) {
          dayChange = 0;
          walletValue = walletBalance;
        } else if (rates[`${_source}${_destination}`]) {
          rateData = rates[`${_source}${_destination}`];
          dayChange = formatNumber(
            rateData.pctChange1d || rateData.pctChange24h,
            exchangeConfig.FIAT_VALUE
          );
          walletValue = formatNumber(walletBalance * rateData.ask, exchangeConfig.FIAT_VALUE);
        } else if (rates[`${_destination}${_source}`]) {
          rateData = rates[`${_destination}${_source}`];
          walletValue = formatNumber(walletBalance / rateData.ask, exchangeConfig.FIAT_VALUE);
          dayChange = formatNumber(
            rateData.pctChange1d || rateData.pctChange24h,
            exchangeConfig.FIAT_VALUE
          );
        } else {
          walletValue = 0;
          dayChange = 0;
        }

        result.totalBalanceInFiat += parseFloat(walletValue);
        if (!Number.isNaN(parseFloat(dayChange))) {
          result.totalChangeInFiat += (dayChange / 100) * walletValue;
        }
      }
    });
  }
  result.totalBalanceInFiat = result.totalBalanceInFiat.toFixed(2);
  result.totalChangeInFiat = result.totalChangeInFiat.toFixed(2);

  return result;
};
